/**
 * Which deployment of PONS is this?
 *
 * The region is read off the hostname — there is no build-time region flag, and
 * one bundle is served to every environment — so these two predicates are THE
 * region signal for the whole app. `defaultMenu` re-exports them (the sidebar
 * has used them the longest), `featureFlags` builds the per-feature gates on
 * top of them, and nothing else should hand-roll a `window.location.hostname`
 * check.
 *
 * They live in their own module rather than in `defaultMenu` so that anything
 * needing the region — a surface layout, a hook, a settings entry — can ask
 * without pulling the menu (and the axios instance behind it) in with it.
 */

/** The EU deployment: `eu.pons.io`. */
export const isEU = (): boolean => window.location.hostname.startsWith('eu.pons.io');

/** The dev deployment: `dev.pons.io`. */
export const isDev = (): boolean => window.location.hostname.startsWith('dev.pons.io');
